import GetState from "../../GetState";
import Table from "../../table/Table";
import { addSpacesToPascalCase, generateId, shortHandDateTime, translate, uniqueSet } from "../../utility/functions";
import { IsAuthorized, userRoles } from "../../RoleProtected";
import LinkTo from "../../forms/LinkTo";

const KioskErrorResponses = ({ parentPage, dataRoute, ...props }) => {
    const canViewCustomers = IsAuthorized(userRoles.viewCustomers);

    const [data] = GetState(dataRoute);

    const getKioskErrorTooltiptext = (errorEnum) => {
        const enums = {
        AppTempIdNotFound: "App Scan Error - Code is invalid",
        AppTempIdExpired: "App Scan Error - Code has expired",
        AppUserInactive: "User Account Error - User account is not active",
        AppUserNotFound: "User Account Error - App User Not Found",
        AppUseLimit: "Usage Restriction - Maximum App redemptions for the configured usage period",
        AwardNotFound: "Configuration Error - Loyalty Award not found",
        AwardUseLimit: "Usage Restriction - Maximum award redemptions for the configured usage period",
        CodeExpired: "Code Error - Code has expired",
        CodeInvalid: "Code Error - Unknown/Invalid code",
        CodeTypeUnknown: "Code Error - Unknown/Invalid code",
        CodeUsed: "Code Error - Code has been used",
        CodeVoided: "Code Error - Code has been voided",
        CreditCardError: "Loyalty Account Error - Credit card information is missing/incomplete",
        InternalError: "System Error - Internal Error",
        InvalidRequest: "System Error - Invalid Request",
        KioskModelUnknown: "Configuration Error - Kiosk model could not be resolved from the request message",
        KioskRestriction: "Usage Restriction - Kiosk is not allowed per configuration",
        KioskTypeUnknown: "Configuration Error - Kiosk type unknown",
        LocationRestriction: "Usage Restriction - Location is not allowed per configuration",
        LoyaltyAccountInactive: "Loyalty Account Error - Loyalty Account is not active",
        LoyaltyAccountNotFound: "Loyalty Account Error - Could not load the loyalty account",
        LoyaltyMemberNotFound: "Loyalty Account Error - Could not load the loyalty member",
        LoyaltyMediaInactive: "Loyalty Account Error - Loyalty Media is not active",
        LoyaltyMediaNotFound: "Loyalty Account Error - Loyalty Media not found",
        PassUseLimit: "Usage Restriction - Maximum pass redemptions for the configured usage period",
        SilverSubscriptionRequired: "Subscription Error - Silver subscription required",
        GoldSubscriptionRequired: "Subsciption Error - Gold subscription required",
        TimerUseLimit: "Usage Restriction - Maximum club timer redemptions for the configured usage period",
        WashClubTimeNotEnabled: "Configuration Error - Wash club timer is not enabled",
        WashClubTimeValueInvalid: "Configuration Error - Wash club timer value is empty or 0 (zero)",
        };
        return enums[errorEnum] || errorEnum;
    };

    const renderCustomerLink = (e) => {
        if(!e.customerId) return;

        if (!canViewCustomers || !e.loyaltyType) return e.customerName;

        if(e.loyaltyType === 'AppWashClub')
            return (<LinkTo target='_blank' customerId={e.customerId}>{e.customerName}</LinkTo>);
        else if (parentPage === 'LoyaltyUser')
            return (<LinkTo to={'/loyaltyMember/' + e.loyaltyMemberId}>{e.customerName}</LinkTo>);
        else
            return (<LinkTo target="_blank" loyaltyAccountId={e.loyaltyAccountId}>{e.customerName}</LinkTo>);
    };

    const tableConfig = {
        tableId: `${parentPage}_KioskResponseErrorsTable`,
        label: "Error Responses (Last 90 days)",
        data: data,
        quickSort: parentPage !== "SubscriptionReports" ? null : //only show filter when on subscriptions report page
        [{
            label: 'Registered Media',
            query: (e) => (e.error === 'LoyaltyMediaNotFound' || e.error === 'AppTempIdNotFound' ? false : true ),
            color: '#000000ff',
            defaultSearch: true
        }, {
            label: 'Unregistered Media',
            query: (e) => (e.error === 'LoyaltyMediaNotFound' || e.error === 'AppTempIdNotFound' ? true : false ),
            color: '#626262ff'
        }],        
        headers: [
        { label: "Location", propKey: "locationName", options: true, show: true },
        { label: "Date/Time", propKey: "requestDateTimeUtc", type: "dateTime"},    
        { label: "Location Date/Time", propKey: "requestDateTimeLocation", type: "dateTime" },            
        { label: "Error", propKey: "error", options: (rows) => uniqueSet(rows.map((r) => r.error)).sort() },
        { label: "Kiosk Display Message", propKey: "displayMessage" },
        { label: "Account", propKey: "customerName", show: parentPage !== 'LoyaltyMember' && parentPage !== 'AppUser' },
        { label: "Media Type", propKey: "mediaType", options: true },
        { label: "Media ID", propKey: "mediaId" }
        ],
        renderFormat: (e) => (
        <tr key={generateId()}>
            <td>{e.locationName}</td>
            <td>{shortHandDateTime(e.requestDateTimeUtc)}</td>   
            <td>{shortHandDateTime(e.requestDateTimeLocation)}</td>           
            <td tooltip={getKioskErrorTooltiptext(e.error)}>{addSpacesToPascalCase(e.error)}</td>
            <td>{e.displayMessage}</td>
            <td>{renderCustomerLink(e)}</td>
            <td>{translate(e.mediaType)}</td>
            <td>{e.mediaId}</td>          
        </tr>
        )
    };

    return <Table config={tableConfig} />;
};

export default KioskErrorResponses;
